// extracted by mini-css-extract-plugin
module.exports = {"Background":"FullBackground_Background__AtXgg"};